enum SystemMessageType {
	WARNING = 'warning',
	INFO = 'info',
}

export default SystemMessageType
